import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.incident-modal-radio-label {
	color: ${dt('incidentModal.radioLabel.color')};
	font-size: ${dt('incidentModal.radioLabel.fontSize')};
	line-height: ${dt('incidentModal.radioLabel.lineHeight')};
	cursor: pointer;
}

.incident-modal-radio-hint {
	color: ${dt('incidentModal.radioHint.color')};
	font-size: ${dt('incidentModal.radioHint.fontSize')};
	line-height: ${dt('incidentModal.radioHint.lineHeight')};
}`;
